import {
  TextInput,
  Grid,
  Stack,
  ScrollArea,
  Button,
  Select,
  LoadingOverlay,
  PasswordInput,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import Map from "components/utilities/Map";
import { CREATE_RETAILER } from "apollo/mutuations";
import { GET_REGIONS, GET_RETAILERS } from "apollo/queries";
import { customLoader } from "components/utilities/loader";
import axios from "axios";
import { API } from "utiles/url";

const RetailerAddModal = ({
  setOpened,
  total,
  setTotal,
  size,
  activePage,
  setActivePage,
}) => {
  const [regionsDropDownData, setRegionsDropDownData] = useState([]);
  const [location, setLocation] = useState({});
  const form = useForm({
    initialValues: {
      name: "",
      _geo: "",
      address: "",
      city: "",
      contact_name: "",
      contact_phone: "",
      contact_email: "",
      region: {
        connect: "1",
      },
      user: {
        create: {
          name: "",
          email: "",
          password: "",
          password_confirmation: "",
          phone: "",
          role: "3",
        },
      },
    },

    validate: {
      "user.create.phone": (value) =>
        /^\d{10}$/.test(value)
          ? null
          : "Phone number must be exactly 10 digits",
      "user.create.password_confirmation": (value, values) =>
        value === values.user.create.password ? null : "Passwords do not match",
    },
  });
  const [addRetailer, { loading: retailerLoading }] = useMutation(
    CREATE_RETAILER,
    {
      update(cache, { data: { createRetailer } }) {
        cache.updateQuery(
          {
            query: GET_RETAILERS,
            variables: {
              first: parseInt(size),
              page: activePage,
              search: "",
              ordered_by: [
                {
                  column: "CREATED_AT",
                  order: "DESC",
                },
              ],
            },
          },
          (data) => {
            if (data) {
              return {
                retailers: {
                  ...data.retailers,
                  data: [createRetailer, ...data.retailers.data],
                },
              };
            }
          }
        );
      },
    }
  );
  const { loading: regionsLoading } = useQuery(GET_REGIONS, {
    variables: {
      first: 100000,
      page: 1,
    },
    onCompleted(data) {
      let regions = data.regions;
      let regionsArray = [];

      regions.data.forEach((region, index) => {
        regionsArray.push({
          label: region?.name,
          value: region?.id,
        });
      });

      setRegionsDropDownData([...regionsArray]);
    },
    onError(err) {
      showNotification({
        color: "red",
        title: "Error",
        message: err?.graphQLErrors?.[0]?.message || "Failed to get regions",
      });
    },
  });

  const { height } = useViewportSize();

  const submit = () => {
    const geoLocation = location
      ? { lat: +location.lat, lng: +location.lng }
      : null;
    addRetailer({
      variables: {
        name: form.getInputProps("name").value,
        contact_name: form.getInputProps("name").value,
        contact_phone: form.getInputProps("user.create.phone").value,
        contact_email: form.getInputProps("user.create.email").value,
        city: form.getInputProps("city").value,
        region: form.getInputProps("region").value,
        address: form.getInputProps("address").value,
        user: {
          create: {
            name: form.getInputProps("name").value,
            email: form.getInputProps("user.create.email").value,
            password: form.getInputProps("user.create.password").value,
            password_confirmation: form.getInputProps(
              "user.create.password_confirmation"
            ).value,
            phone: form.getInputProps("user.create.phone").value,
            role: "3",
          },
        },
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Retailer Created Successfully",
        });
        setOpened(false);
      },
      onError(error) {
        setOpened(true);
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to add retailer",
        });
      },
    });
  };

  const setRegionDropDownValue = (val) => {
    form.setFieldValue("region.connect", val);
  };

  return (
    <>
      <LoadingOverlay
        visible={regionsLoading || retailerLoading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={4}>
                <TextInput
                  required
                  label="Name"
                  placeholder="Name"
                  {...form.getInputProps("name")}
                />
                <TextInput
                  required
                  label="Phone"
                  placeholder="Phone"
                  {...form.getInputProps("user.create.phone")}
                />
                <TextInput
                  required
                  label="Email"
                  placeholder="Email"
                  {...form.getInputProps("user.create.email")}
                />
                <PasswordInput
                  placeholder="Password"
                  label="Password"
                  {...form.getInputProps("user.create.password")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <Select
                  data={regionsDropDownData}
                  searchable
                  value={form.getInputProps("region.connect")?.value.toString()}
                  onChange={setRegionDropDownValue}
                  label="Region"
                  placeholder="Pick a region this retailer belongs to"
                />
                <TextInput
                  label="Street Address"
                  placeholder="Street Address"
                  {...form.getInputProps("address")}
                />
                <TextInput
                  required
                  label="City"
                  placeholder="City"
                  {...form.getInputProps("city")}
                />
                <PasswordInput
                  placeholder="Confirm Password"
                  label="Confirm Password"
                  {...form.getInputProps("user.create.password_confirmation")}
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={4}>
                <Button
                  style={{
                    width: "25%",
                    marginTop: "15px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  type="submit"
                  fullWidth
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};

export default RetailerAddModal;
